type MetricTileProps = {
  label: string;
  value: string;
  detail: string;
};

export function MetricTile({ label, value, detail }: MetricTileProps) {
  return (
    <div className="ui-metric-tile">
      <span>{label}</span>
      <strong>{value}</strong>
      <small>{detail}</small>
    </div>
  );
}
